import { Text } from '@thefarmersfront/kitchen';

import { FormField, ModalSection } from '~/components/common';

import type { CollectingOutboundDetail } from '~/types/delivery-agency.types';

import styles from './CollectingRequestRegisterModal.module.scss';

/** [반품 신청 2step] 1step에서 선택한 원주문 정보. 조회 전용이다 */
const CollectingRequestOriginalOrderInfo = ({ detail }: { detail: CollectingOutboundDetail }) => {
  const rows = [
    { label: '출고번호', value: detail.outboundCode },
    { label: '판매처 주문번호(원주문)', value: detail.clientOrderCodes.join(', ') },
    { label: '상품명', value: detail.productNames.join(', ') },
    { label: '수령자명', value: detail.receiverName },
    { label: '수령자 연락처', value: detail.receiverContact },
    { label: '도로명 기본주소', value: detail.primaryAddress },
    { label: '상세주소', value: detail.secondaryAddress },
    { label: '상품수령장소', value: detail.deliveryLocation?.description ?? '-' },
    { label: '상품수령장소 상세', value: detail.deliveryLocationDetail },
    { label: '출입방법', value: detail.entranceMethod?.description ?? '-' },
    { label: '출입방법 상세', value: detail.entranceMethodDetail },
  ];

  return (
    <ModalSection title="원주문 정보">
      {rows.map(({ label, value }) => (
        <FormField
          key={label}
          label={label}
          contentsClassName={styles['field-value']}
          contents={
            <Text className={styles['field-text']} size="large" element="span">
              {value || '-'}
            </Text>
          }
        />
      ))}
    </ModalSection>
  );
};

export default CollectingRequestOriginalOrderInfo;
